export default __webpack_public_path__ + "static/media/rocket_anim_126.9895d027.png";